import FormLabel from "./FormLabel";
import CustomIcon from "../CustomIcon";


const Input = ({
                 type,
                 value,
                 onChange,
                 label,
                 placeholder,
                 isRequired = true,
                 errorMessage,
                 hasLabel = true,
                 hideError = false,
                 preIcon,
                 postIcon,
                 name,
                 className,
                 labelClass,
                 labelComponent,
                 disabled,
                 formLabelTrailing,
                 maxLength,
                 ...props
               }) => {

  const handleWheel = (e) => {
      e.target.blur()
  };

  return <div className={`${disabled ? "text-gray-400 " : ""}mb-1 w-full`}>
    {hasLabel &&
      (labelComponent ?? <FormLabel label={label ?? placeholder} isRequired={isRequired} className={labelClass} trailing={formLabelTrailing}/>)
    }

    <div className="relative w-full">
      {!!preIcon && <span className="absolute text-sm text-gray-400 leading-10 bottom-0 top-0 px-2 left-0">{preIcon}</span>}
      <input
        className={`form-control ${className ? className : ""} ${postIcon && preIcon ? 'pr-12 pl-12' : postIcon ? 'pr-12 pl-4' : preIcon ? 'pr-4 pl-12' : 'px-4'}`}
        onWheel={handleWheel}
        type={type} value={value} onChange={onChange} placeholder={placeholder} name={name} disabled={disabled} maxLength={maxLength} {...props}/>
      {!!postIcon && <span className="absolute text-sm text-gray-400 leading-10 bottom-0 top-0 px-3 right-0">{postIcon}</span>}
    </div>
    {!hideError && <div className="h-4 text-xs text-error-500">{errorMessage}</div>}
  </div>;
};


export default Input;

export const InputIcon = ({icon, size = "xl", right = true, ...props}) => {
  return (
    <CustomIcon icon={icon}
                className={`select-none text-rand-100 cursor-pointer leading-10 px-2 ${right ? 'right-0' : 'left-0'}`}
                size={size} {...props}/>
  );
};
